<template>
  <div class="agr">
    <!-- 导航栏 -->
    <nav-header :href="this.href"></nav-header>

    <div class="container">
      <h1>为保障未成年人的相应权利公司制定以下制度</h1>
      <h2>
        1、公司严格按照法律要求对未成年人个人信息实施加密保护措施；对于处理不满十四周岁的未成年人个人信息公司明确要求必须征得未成年人父母或其他监护人同意方可处理，未经监护人同意一律不得擅自处理未成年人个人信息。
      </h2>

      <h2>2、我公司如发现未成年人通过我平台发布私密信息，会即刻通知技术安全部门，对发布的私密信息进行屏蔽及进一步措施并查阅该用户的有关信息，以便于进行后续确认及沟通。</h2>
      <!-- <p>
        2.1儿童的个人信息属于敏感个人信息，请父母或监护人谨慎对待儿童个人信息,教育引导儿童增强个人信息保护意识和能力，指导、提醒和要求他们在未经您同意的情况下，不
        向任何网络产品和服务提供者提供任何个人信息，并确保您的孩子的相关操作(如授权、信息提供等)在您的同意后进行。
      </p>
      <p>2.2如果未取得父母或监护人的同意,儿童不应创建自己的个人信息主体账户。</p>
      <p>
        2.3对于经父母或监护人同意而收集儿童个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护儿童所必要的情祝下使用或公开披露此信息。
      </p> -->

      <h2>
        3、公司在产品内容方面尽量开发/上架一些不会引起未成年人沉迷的产品，如有关产品有连载功能有可能会导致用户长期沉迷于该产品的，我们会进行时长控制，比如每周不超8小时的控制方式来进行时长监测。在权限控制方面我们会对其账号进行短暂封锁，在消费相关网络文化产品时对其金额进行限制。每周消费不得超出一定的金额。
      </h2>

      <h2>4、未成年人用户注册时必须要通过实名认证，后台应对认证信息进行核对，并征得其父母或者其他监护人同意。避免因无完全民事行为能力产生不必要的纠纷，导致公司利益或者用户权益受损。</h2>
      <h2>5、为更好的开展网络文化业务，我们建立了便捷、合理、有效的投诉和举报通道。在网站平台底端可以查看，供用户监督我平台运作。如发生投诉或举报即刻成立专项组，尽快给出答复。</h2>
      <h2>6、结合社会实事，适当的更改或指定未成年人保护制度。争取做到全面。</h2>
      <h2>7、若平台发现有用户发布可能危害未成年人的不良信息，包含图片、文字等内容。应该要求该用户停止发布或者在发布时做出提醒。一旦发现上述情况，必须立即采取删除、屏蔽等防控措施。并保存相应记录，向网信、公安等部门报告。</h2>
      <div class="blink"></div>
    </div>
  </div>
</template>

<script>
import NavHeader from "./../components/h2";
export default {
  name: "agreement",
  components: {
    NavHeader,
  },
  data() {
    return {
      href: "index.html",
    };
  },
  mounted() {
    document.title = "晋江奇境 ";
  },
};
</script>
<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";
.agr {
  .container {
    width: 980px;
    padding-top: 30px;
    h1 {
      font-size: 18px;
      font-weight: bold;
    }
    h2 {
      font-size: 16px;
      font-weight: bold;
      color: #333;
      margin: 20px 0;
      line-height: 31px;
    }

    p {
      text-indent: 30px;
      font-size: 14px;
      line-height: 31px;
      margin: 20px 0 40px;
      color: #888;
    }

    h3 {
      font-size: 16px;
      font-weight: bold;
      color: #333;
      margin: 15px 0;
      span {
        font-size: 14px;
        color: #888;
        font-weight: normal;
      }
    }

    .blink {
      width: 100%;
      height: 1px;
      background: #ccc;
      margin-bottom: 30px;
    }
  }
}
</style>
